var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#F2F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 52L62.122 47.7678C59.0676 45.5687 54.8934 45.796 52.0958 48.3138L43.9042 55.6862C41.1066 58.204 36.9324 58.4313 33.878 56.2322L28 52M36 68H60C64.4183 68 68 64.4183 68 60V36C68 31.5817 64.4183 28 60 28H36C31.5817 28 28 31.5817 28 36V60C28 64.4183 31.5817 68 36 68ZM46 41C46 43.7614 43.7614 46 41 46C38.2386 46 36 43.7614 36 41C36 38.2386 38.2386 36 41 36C43.7614 36 46 38.2386 46 41Z",
    stroke: "#AFBACA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoImg);
export default __webpack_public_path__ + "static/media/demo-img.39ba0bb3feca145d4380cc26cd072d60.svg";
export { ForwardRef as ReactComponent };